import { createContext, useContext } from "react";

// Availability only. This does not grant access or replace managed validation.
export const SharedLoginContext = createContext(false);
export const useSharedLoginAvailable = () => useContext(SharedLoginContext);
